import React, {useState, useEffect} from 'react';
import {getThemeName} from "../../utils/themeUtils";


function ThemableSvgIcon(props) {
    const themeName = getThemeName();
    const [icons, setIcons] = useState(false);

    useEffect(() => {
        (async()=>{
            let importedIcon = await import(`../../resources/images/theme/${themeName}/icons.svg`);
            setIcons(importedIcon.default);
        })();
    }, []);

    return (
        <svg className={`fill-current stroke-current ${props.className}`}>
            {icons && <use xlinkHref={`${icons}#icon-${props.name}`} />}
        </svg>
    );
}

export default ThemableSvgIcon;